
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7583_360)"}},[_c('path',{attrs:{"d":"M8 4.52v2.025l2.857-2.7L8 1.142v2.026c-3.157 0-5.714 2.417-5.714 5.402 0 1.06.328 2.043.885 2.877l1.043-.986a3.831 3.831 0 01-.5-1.89c0-2.24 1.918-4.053 4.286-4.053zm4.829 1.175l-1.043.986c.318.563.5 1.205.5 1.89 0 2.24-1.918 4.052-4.286 4.052v-2.026L5.143 13.3 8 16v-2.026c3.157 0 5.714-2.418 5.714-5.403 0-1.06-.328-2.042-.885-2.876z","fill":"#58697D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7583_360"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    